import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  mb2: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
